import React from 'react';
import styled from 'styled-components';
import { Switch } from 'antd';

const RadioSwitchLabelContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  :not(:last-child) {
    margin-right: 14px;
  }
`;

const Label = styled.p`
  font-size: 12px;
  margin-bottom: 17.5px;
  text-transform: uppercase;
  color: ${(props) => props.theme.colors['dark']};
  font-family: ${(props) => props.theme.fonts.oswald};
`;

const RadioSwitchGroupContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;

  .ant-switch {
    background-color: ${(props) => props.theme.colors['grey-two']};
    margin: 0;

    &.ant-switch-checked {
      background-color: ${(props) => props.theme.colors['terra-cotta']};
    }
  }
`;

const RadioSwitchs = ({ label, disabled, onChange, checked }) => (
  <div>
    {label && <Label>{label}</Label>}
    <RadioSwitchGroupContainer>
      <RadioSwitchLabelContainer key={`radioSwitch`}>
        <Switch disabled={disabled} checked={checked} onChange={onChange} />
      </RadioSwitchLabelContainer>
    </RadioSwitchGroupContainer>
  </div>
);

export default RadioSwitchs;
